export default __webpack_public_path__ + "assets/3daaf9.svg";